



























import { ILocale } from "@/@types/locale";
import { Component, Prop, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
import StandartModal from "@/components/app/standart-modal.vue";

interface ICategory {
  _id: string | undefined;
  name: ILocale;
  show: boolean;
  sort_order: number | undefined;
  src: {
    poster: string;
    background: string;
  };
}

@Component({ components: { StandartModal, draggable } })
export default class SortModal extends Vue {
  @Prop({ type: String, default: "sort-modal" }) modal!: string;
  @Prop({ type: Array, default: [] }) list!: Array<ICategory>;

  categorys: Array<ICategory> = [];
  enabled = true;
  dragging = false;

  onSaveSorts(): void {
    this.$bvModal.hide(this.modal);
    this.$emit("sort", this.list);
  }
}
